import { COMPANY } from "../data/insurances";

const pages = {
  privacidade: {
    title: "Política de Privacidade",
    subtitle: "Em conformidade com a LGPD (Lei 13.709/2018)",
    sections: [
      {
        h: "1. Informações que coletamos",
        p: "A Safe Life coleta os dados que você voluntariamente fornece em nossos formulários (nome, e-mail, WhatsApp, cidade, UF e dados específicos para cotação) e dados de navegação (cookies, IP, tipo de dispositivo). Esses dados são usados exclusivamente para gerar cotações e prestar atendimento consultivo.",
      },
      {
        h: "2. Como usamos seus dados",
        p: "Seus dados são usados para: (i) gerar cotações junto às seguradoras parceiras; (ii) contato consultivo via WhatsApp, e-mail ou telefone; (iii) envio de propostas e apólices; (iv) cumprimento de obrigações legais e regulatórias. Jamais vendemos ou cedemos seus dados para fins comerciais não autorizados.",
      },
      {
        h: "3. Compartilhamento com terceiros",
        p: "Compartilhamos seus dados apenas com as seguradoras parceiras (Porto Seguro, Tokio Marine, Grupo HDI, Allianz, Suhai, Ituran) e outros parceiros técnicos estritamente necessários para a prestação do serviço, sempre mediante cláusulas contratuais de proteção de dados.",
      },
      {
        h: "4. Seus direitos (LGPD)",
        p: "Você tem direito a: (i) confirmar a existência de tratamento; (ii) acessar seus dados; (iii) corrigir dados incompletos ou incorretos; (iv) solicitar anonimização, bloqueio ou eliminação; (v) portabilidade; (vi) revogar consentimento. Para exercer esses direitos, escreva para " + COMPANY.email + ".",
      },
      {
        h: "5. Retenção e segurança",
        p: "Mantemos seus dados apenas pelo tempo necessário para as finalidades descritas e pelo prazo legal aplicável (até 5 anos após o fim do relacionamento). Adotamos medidas técnicas e organizacionais adequadas para proteger seus dados contra acesso não autorizado.",
      },
      {
        h: "6. Contato do Encarregado (DPO)",
        p: "Para assuntos relacionados à proteção de dados, entre em contato pelo e-mail " + COMPANY.email + " com o assunto \"LGPD\".",
      },
    ],
  },
  termos: {
    title: "Termos de Uso",
    subtitle: "Última atualização: 2026",
    sections: [
      {
        h: "1. Sobre a Safe Life",
        p: COMPANY.name + " é uma corretora de seguros inscrita no CNPJ " + COMPANY.cnpj + " e registrada na SUSEP sob o código " + COMPANY.susep + ". Atuamos como intermediária entre o cliente e as seguradoras parceiras.",
      },
      {
        h: "2. Uso do site",
        p: "Ao acessar este site, você concorda em usá-lo apenas para fins lícitos e de forma compatível com estes Termos. É proibido tentar obter acesso não autorizado a qualquer parte do site, extrair dados em massa ou utilizar o site para atividades fraudulentas.",
      },
      {
        h: "3. Cotações",
        p: "As cotações geradas através deste site são referenciais e não vinculam a Safe Life nem as seguradoras parceiras. O valor final, coberturas e condições serão confirmados na apólice formal, após análise de risco e aceitação pela seguradora.",
      },
      {
        h: "4. Propriedade intelectual",
        p: "Todo o conteúdo deste site (textos, imagens, logo, layout) é de propriedade da Safe Life ou utilizado sob licença. Reprodução não autorizada é proibida.",
      },
      {
        h: "5. Limitação de responsabilidade",
        p: "A Safe Life empenha-se em manter o site atualizado e disponível, mas não garante sua ininterrupção. Não nos responsabilizamos por decisões tomadas com base exclusivamente no conteúdo deste site sem consultoria especializada.",
      },
      {
        h: "6. Foro",
        p: "Estes Termos são regidos pelas leis da República Federativa do Brasil. Fica eleito o foro da comarca de Jales/SP.",
      },
    ],
  },
  cookies: {
    title: "Política de Cookies",
    subtitle: "Como usamos cookies em nosso site",
    sections: [
      {
        h: "1. O que são cookies",
        p: "Cookies são pequenos arquivos de texto armazenados no seu navegador quando você visita um site. Eles ajudam o site a lembrar suas preferências e a oferecer uma experiência personalizada.",
      },
      {
        h: "2. Tipos de cookies que usamos",
        p: "Cookies essenciais: necessários para o funcionamento do site (por exemplo, autenticação do painel admin). Cookies de desempenho: coletam informações anônimas sobre como você usa o site. Cookies de funcionalidade: lembram preferências (idioma, consentimento LGPD).",
      },
      {
        h: "3. Gerenciamento",
        p: "Você pode aceitar ou recusar cookies através do banner exibido na sua primeira visita. Também pode gerenciar cookies diretamente nas configurações do seu navegador.",
      },
      {
        h: "4. Contato",
        p: "Dúvidas sobre cookies? Escreva para " + COMPANY.email + ".",
      },
    ],
  },
};

export default function LegalPage({ kind }) {
  const data = pages[kind];
  if (!data) return null;
  return (
    <div className="py-16 md:py-24 min-h-[70vh]" data-testid={`legal-page-${kind}`}>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl">
        <p className="text-lego text-sm font-bold uppercase tracking-widest mb-3">Documento legal</p>
        <h1 className="font-heading text-3xl md:text-5xl font-extrabold text-navy">{data.title}</h1>
        <p className="mt-3 text-navy/60">{data.subtitle}</p>

        <div className="mt-10 space-y-8">
          {data.sections.map((s, i) => (
            <div key={i} className="bg-surface rounded-2xl p-6 md:p-8 border border-navy-100">
              <h2 className="font-heading text-xl font-bold text-navy mb-3">{s.h}</h2>
              <p className="text-navy/80 leading-relaxed">{s.p}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
